import{_ as o}from"./custom-element-CDWT-yC_.js";import{n as t}from"./property-DeTTNf1t.js";function e(e){class r extends e{constructor(){super(...arguments),this.autocomplete="off"}}return o([t()],r.prototype,"autocomplete",void 0),r}export{e as A};
//# sourceMappingURL=AutocompleteMixin-Dk_gVU09.js.map
